import OfferDialog from "./OfferDialog";

export default OfferDialog;
